import styled from 'styled-components';

export const TabContainerWrapper = styled.div`
  gap: ${({ theme }) => theme.spacing.s};
  margin: 0 ${({ theme }) => theme.spacing.m};
  display: flex;
  list-style: none;
  overflow-x: auto;
  overflow-y: hidden;
`;

export const TabContainterContent = styled.div``;

export const TitleTabsContainer = styled.div`
  border-bottom: ${({ theme }) => `1px ${theme.colors.platinum} solid`};
  margin-bottom: ${({ theme }) => theme.spacing.m};
  padding: 0 ${({ theme }) => theme.spacing.m};
`;

export const TitleTabsContent = styled.div`
  padding-bottom: ${({ theme }) => theme.spacing.s};
`;

export const TabsTitle = styled.div`
  position: ${({ theme }) => theme.positions.relative};
  width: fit-content;

  &::before {
    content: '';
    position: ${({ theme }) => theme.positions.absolute};
    bottom: -9px;
    left: 0;
    width: 100%;
    height: 2px;
    border-radius: ${({ theme }) => theme.radius.m};
    background-color: ${({ theme }) => theme.colors.verdigrisDark};
  }
`;
